import { render, staticRenderFns } from "./HomeTeacherList.vue?vue&type=template&id=64789e1f&scoped=true&"
import script from "./HomeTeacherList.vue?vue&type=script&lang=js&"
export * from "./HomeTeacherList.vue?vue&type=script&lang=js&"
import style0 from "./HomeTeacherList.vue?vue&type=style&index=0&id=64789e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64789e1f",
  null
  
)

export default component.exports